{
  "WHATSAPP_TEMPLATE_MGMT": {
    "TITLE": "Sablonok",
    "DESCRIPTION": "Tekintsd meg a WhatsApp postafiókjaidból szinkronizált üzenetsablonokat. Sablon létrehozásához vagy szerkesztéséhez használd a szolgáltatódat.",
    "COUNT": "{n} sablon",
    "LEARN_MORE": "Tudj meg többet a WhatsApp sablonokról",
    "SYNC_TEMPLATES": "Sablonok szinkronizálása",
    "SYNC_SUCCESS": "Elindult a sablonok szinkronizálása minden WhatsApp postafiókhoz. A frissítés eltarthat néhány percig.",
    "PARTIAL_SYNC_ERROR": "Elindult a sablonok szinkronizálása néhány WhatsApp postafiókhoz, de másoknál ez nem sikerült.",
    "SYNC_ERROR": "Nem sikerült elindítani a sablonok szinkronizálását. Kérjük, próbáld újra.",
    "SEARCH_PLACEHOLDER": "Keresés tartalom vagy név alapján...",
    "MANAGE_IN_META": "Kezelés a Metában",
    "LOADING": "WhatsApp sablonok betöltése...",
    "EMPTY": "Nem találtunk WhatsApp sablonokat.",
    "NO_RESULTS": "Egyetlen sablon sem felel meg a szűrőknek.",
    "FETCH_ERROR": "Nem sikerült betölteni a WhatsApp sablonokat. Kérjük, próbáld újra.",
    "PARTIAL_FETCH_ERROR": "Néhány WhatsApp sablont nem sikerült betölteni. Kérjük, próbáld újra.",
    "LAST_SYNC_ATTEMPT": "Utolsó szinkronizálási kísérlet: {date}",
    "MORE_INBOXES": "+{n}",
    "STATUSES": {
      "UNSUBMITTED": "Nincs beküldve WhatsApp jóváhagyásra"
    },
    "FILTERS": {
      "ALL_INBOXES": "Minden postafiók",
      "ALL_LANGUAGES": "Minden nyelv",
      "ALL_TYPES": "Minden típus"
    },
    "TYPES": {
      "TEXT": "Szöveg",
      "IMAGE": "Kép",
      "VIDEO": "Videó",
      "DOCUMENT": "Dokumentum",
      "CALL_TO_ACTION": "Cselekvésre ösztönzés",
      "COPY_CODE": "Kód másolása"
    },
    "PREVIEW": {
      "TITLE": "Sablon előnézete",
      "DESCRIPTION": "Nézd meg, hogyan jelenik meg ez a sablon a WhatsAppban.",
      "OPEN": "{name} előnézete",
      "CLOSE": "Előnézet bezárása",
      "DETAILS": "Sablon részletei",
      "STATUS": "Státusz",
      "TYPE": "Tartalomtípus",
      "CATEGORY": "Kategória",
      "LANGUAGE": "Nyelv",
      "INBOXES": "Postafiókok"
    }
  }
}
